export default __webpack_public_path__ + "static/media/frog-preview.6f14dae0.svg";